<div class="rounded-2xl bg-primary-50 border border-gray-300 p-6">
  <h2 class="text-lg font-semibold mb-2">{{ title }}</h2>

  <p class="text-sm text-gray-500 mb-4">
    {{ helpText }}
    <br />
    <span class="font-medium">{{ footerNote }}</span>
    &nbsp;(máx. {{ maxFileSize / (1024 * 1024) | number: '1.0-0' }} MB)
  </p>

  <p-fileupload
    (onSelect)="onSelect($event)"
    (uploadHandler)="onUpload($event)"
    [accept]="acceptFile"
    [auto]="false"
    [customUpload]="true"
    [disabled]="disabled || isBusy()"
    [maxFileSize]="maxFileSize"
    [multiple]="multiple"
    cancelLabel="Limpiar"
    chooseLabel="Seleccionar"
    class="block"
    mode="advanced"
    name="files"
    uploadLabel="Validar"
  >
    <!-- HEADER con acciones: elegir / validar / limpiar -->
    <ng-template
      #header
      let-chooseCallback="chooseCallback"
      let-clearCallback="clearCallback"
      let-files
      let-uploadCallback="uploadCallback"
    >
      <div class="flex flex-wrap justify-between items-center flex-1 gap-4 w-full">
        <div class="flex gap-2">
          <p-button (onClick)="chooseCallback()" icon="pi pi-upload" pTooltip="Elegir archivo(s)" />
          @if (!hideUploadButton) {
            <p-button
              (onClick)="uploadCallback()"
              [disabled]="!files || files.length === 0"
              [outlined]="true"
              icon="pi pi-check"
              pTooltip="Validar selección"
              severity="success"
            />
          }
          <p-button
            (onClick)="onClearFiles(clearCallback)"
            [disabled]="!files || files.length === 0"
            icon="pi pi-times"
            pTooltip="Limpiar"
            severity="danger"
          />
        </div>

        <!-- Barra de progreso opcional; aquí no subimos, pero puedes mostrar tamaño total -->
        @if (files?.length) {
          <div class="text-xs text-gray-500 ml-auto">
            {{ files.length }} archivo(s) seleccionados
          </div>
        }
      </div>
    </ng-template>

    <!-- CONTENT: lista de pendientes / cargados (aquí solo pendientes, no hay “uploaded” real) -->
    <ng-template #content let-files let-removeFileCallback="removeFileCallback">
      <div class="flex flex-col gap-4 pt-4">
        @if (files?.length > 0) {
          <div>
            @for (file of files; track file; let i = $index) {
              <div
                class="p-4 rounded border border-gray-200 items-center gap-3 flex flex-col md:flex-row justify-between"
              >
                <div class="flex items-center gap-2">
                  <i class="pi pi-file"></i>
                  <div class="min-w-0">
                    <div
                      class="font-medium line-clamp-2 text-ellipsis max-w-60 whitespace-nowrap overflow-hidden"
                    >
                      {{ file.name }}
                    </div>
                    <div class="text-xs text-gray-500">{{ formatSize(file.size) }}</div>
                  </div>
                </div>
                <p-badge class="ml-2" severity="warn" value="Pendiente" />
              </div>
            }
          </div>
        }
      </div>
    </ng-template>

    <!-- Archivo individual (no necesitamos item custom aquí) -->
    <ng-template #file></ng-template>

    <!-- EMPTY -->
    <ng-template #empty>
      <div
        class="flex items-center justify-center flex-col bg-gray-50 rounded-xl p-4 text-gray-500 border border-dashed border-gray-300"
      >
        <p class="mb-6">No hay archivos seleccionados.</p>
        <i class="pi pi-file-arrow-up !border-2 !rounded-full !p-8 !text-4xl !text-gray-400"></i>
        <p class="mt-6 mb-0">Arrastra y suelta aquí para seleccionar.</p>
      </div>
    </ng-template>
  </p-fileupload>
</div>
